import type { Campaign } from 'c-sdk';
import { usesInsertionOrderTargeting } from 'c-main/Lib/Campaign/insertionOrderTargeting';
import { settledTarget } from 'c-main/Lib/Campaign/settledTarget';

export type DspReportTarget = {
    /** The "Total Target" figure; null shows a dash. */
    expected: number | null;
    /** "Total of Target Delivered to Date", already a percentage; null shows a dash. */
    percent: number | null;
};

/**
 * UL-8133 -- Expected and the delivery % on the DSP PCA report.
 *
 * `vistar_us2` reads the settled figures the builder writes on live runs, exactly as the analytics
 * headline and the campaign list do (`settledTarget`). Every other DSP type keeps the report as it
 * was: the campaign's Expected Impressions and impacts ÷ expected (0% when nothing is expected).
 */
export const dspReportTarget = (
    campaign:
        | Pick<Campaign, 'type' | 'expected_impacts' | 'playout_stats' | 'playout_percentage'>
        | null
        | undefined,
    impacts: number,
): DspReportTarget => {
    if (usesInsertionOrderTargeting(campaign)) {
        const { target, percent } = settledTarget(campaign);
        return { expected: target, percent };
    }

    const expected = Number(campaign?.expected_impacts ?? 0) || 0;
    return { expected, percent: expected > 0 ? (impacts / expected) * 100 : 0 };
};
